import { useMetaTags } from 'react-metatags-hook';

const MetaTagsComponent = ({ lang = 'ru' }) => {
  const ruMeta = {
    title: 'С4U | Курсы вайб-кодинга для украинцев за рубежом',
    description: 'Бесплатные курсы по созданию IT-продуктов с помощью ИИ для украинцев в эвакуации',
    keywords: 'вайб-кодинг, курсы для украинцев, IT обучение, создание IT-продуктов, ИИ в программировании, бесплатные курсы, обучение за рубежом',
    ogTitle: 'С4U | Курсы вайб-кодинга для украинцев за рубежом',
    ogDescription: 'Бесплатные курсы по созданию IT-продуктов с помощью ИИ для украинцев в эвакуации',
    ogLocale: 'ru_RU',
    url: 'https://c4u-uk.com/'
  };

  const ukMeta = {
    title: 'С4U | Курси вайб-кодінгу для українців за кордоном',
    description: 'Безкоштовні курси з створення IT-продуктів за допомогою ШІ для українців в евакуації',
    keywords: 'вайб-кодінг, курси для українців, IT навчання, створення IT-продуктів, ШІ в програмуванні, безкоштовні курси, навчання за кордоном',
    ogTitle: 'С4U | Курси вайб-кодінгу для українців за кордоном',
    ogDescription: 'Безкоштовні курси з створення IT-продуктів за допомогою ШІ для українців в евакуації',
    ogLocale: 'uk_UA',
    url: 'https://c4u-uk.com/ua'
  };

  const meta = lang === 'uk' ? ukMeta : ruMeta;

  useMetaTags(
    {
      title: meta.title,
      description: meta.description,
      lang: lang,
      metas: [
        { name: 'keywords', content: meta.keywords },
        { name: 'robots', content: 'noodp' }
      ],
      links: [
        { rel: 'alternate', hreflang: 'ru', href: 'https://c4u-uk.com/' },
        { rel: 'alternate', hreflang: 'uk', href: 'https://c4u-uk.com/ua' },
        { rel: 'alternate', hreflang: 'x-default', href: 'https://c4u-uk.com/' }
      ],
      openGraph: {
        type: 'website',
        url: meta.url,
        title: meta.ogTitle,
        description: meta.ogDescription,
        locale: meta.ogLocale,
        image: '%PUBLIC_URL%/presentation.webp',
        'image:width': '1200',
        'image:height': '630'
      },
      twitter: {
        card: 'summary',
        url: meta.url,
        title: meta.ogTitle,
        description: meta.ogDescription,
        image: '%PUBLIC_URL%/presentation.webp'
      }
    },
    [lang]
  );

  return null;
};

export { MetaTagsComponent }; 